(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-description-tabs"] && !Shopify.designMode) return;
  try {
    
  const initializeProductInfoTabs = (root) => {
    if (!root || root.dataset.tabsReady === 'true') return;

    const descriptionPanel = root.querySelector('[id^="description-panel-"]');
    const detailsTarget = root.querySelector('[data-product-details-target]');
    const detailsMedia = descriptionPanel?.querySelector('.product-description-media');

    if (detailsTarget && detailsMedia) {
      detailsTarget.appendChild(detailsMedia);
    }

    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));

    const activateTab = (tab, moveFocus = false) => {
      tabs.forEach((item) => {
        const isActive = item === tab;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', String(isActive));
        item.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach((panel) => {
        const isActive = panel.id === tab.getAttribute('aria-controls');
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', String(!isActive));
      });

      if (moveFocus) tab.focus();
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateTab(tab));

      tab.addEventListener('keydown', (event) => {
        let nextIndex = index;

        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;

        if (nextIndex !== index) {
          event.preventDefault();
          activateTab(tabs[nextIndex], true);
        }
      });
    });

    root.dataset.tabsReady = 'true';
  };

  document.querySelectorAll('[data-product-info-tabs]').forEach(initializeProductInfoTabs);

  document.addEventListener('shopify:section:load', (event) => {
    initializeProductInfoTabs(event.target.querySelector('[data-product-info-tabs]'));
  });

  } catch(e) { console.error(e); }
})();
})();
